// frontend/src/farm/farmStorage.mjs — what the 📦 Schowek lists (pure, node --test).
const ORDER = { landmark: 0, plaque: 1, decoration: 2, fence: 3, hay: 4, tree: 5, hut: 6, waiting: 7 };

export function storageItems(raw) {
  const fc = raw?.catalog?.farm ?? {};
  const out = [];
  const add = (item, count) => {
    if (!(count > 0)) return;
    const plaque = item.startsWith('plaque:');
    const spec = plaque ? fc.objects?.plaque : fc.objects?.[item];
    if (!spec) return;
    const name = plaque ? `${spec.name_pl}: ${fc.crops?.[item.slice(7)]?.name_pl ?? item.slice(7)}` : spec.name_pl;
    out.push({ item, name, count, kind: spec.kind });
  };
  for (const [item, n] of Object.entries(raw?.farm?.storage ?? {})) add(item, n);
  for (const [item, n] of Object.entries(raw?.inventory?.unplaced_decorations ?? {})) add(item, n);
  // 4c: animals waiting for a hut of their kind — shown, not placeable.
  for (const [sp, q] of Object.entries(raw?.farm?.waiting_animals ?? {})) {
    if (q?.length) out.push({ item: `wait:${sp}`, name: `Czekają: ${fc.animals?.[sp]?.name_pl ?? sp}`, count: q.length, kind: 'waiting' });
  }
  return out.sort((a, b) => ORDER[a.kind] - ORDER[b.kind] || a.name.localeCompare(b.name));
}

export function storageCount(raw) { return storageItems(raw).reduce((s, i) => s + i.count, 0); }

export const STORAGE_PAGE = 8;
export function storagePage(items, page) {
  const pages = Math.max(1, Math.ceil(items.length / STORAGE_PAGE));
  const p = Math.min(Math.max(0, page), pages - 1);
  return { items: items.slice(p * STORAGE_PAGE, (p + 1) * STORAGE_PAGE), page: p, pages };
}
